import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function StoreIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 19 20"
      style={{ fill: "none", ...(props.style || {}) }}
    >
      <path
        d="M7.6002 15.6749V16.2924H8.2177V15.6749H7.6002ZM3.3252 15.6749H2.7077C2.7077 16.016 2.98416 16.2924 3.3252 16.2924V15.6749ZM15.6751 15.6749V16.2924C16.0162 16.2924 16.2926 16.016 16.2926 15.6749H15.6751ZM11.4002 15.6749H10.7827V16.2924H11.4002V15.6749ZM16.2926 9.97516C16.2926 9.63412 16.0162 9.35766 15.6751 9.35766C15.3341 9.35766 15.0576 9.63412 15.0576 9.97516H16.2926ZM3.9427 9.97516C3.9427 9.63412 3.66623 9.35766 3.3252 9.35766C2.98416 9.35766 2.7077 9.63412 2.7077 9.97516H3.9427ZM7.6002 15.0574H3.3252V16.2924H7.6002V15.0574ZM15.6751 15.0574H11.4002V16.2924H15.6751V15.0574ZM12.0177 15.6749V13.7749H10.7827V15.6749H12.0177ZM6.9827 13.7749V15.6749H8.2177V13.7749H6.9827ZM15.0576 9.97516V15.6749H16.2926V9.97516H15.0576ZM3.9427 15.6749V9.97516H2.7077V15.6749H3.9427ZM9.5002 11.2574C8.10982 11.2574 6.9827 12.3846 6.9827 13.7749H8.2177C8.2177 13.0666 8.79189 12.4924 9.5002 12.4924V11.2574ZM12.0177 13.7749C12.0177 12.3845 10.8906 11.2574 9.5002 11.2574V12.4924C10.2085 12.4924 10.7827 13.0666 10.7827 13.7749H12.0177Z"
        fill="currentColor"
      />
      <path
        d="M16.625 8.55001C16.1293 9.37502 15.2413 9.97501 14.25 9.97501C13.3207 9.97501 12.3087 9.37502 11.875 8.55001C11.3793 9.37502 10.4913 10.0344 9.5 10.0344C8.57065 10.0344 7.5587 9.37502 7.125 8.55001C6.62935 9.37502 5.7413 9.97501 4.75 9.97501C3.82065 9.97501 2.8087 9.37502 2.375 8.55001V6.65001L4.75 3.32501H14.25L16.625 6.65001V8.55001Z"
        stroke="currentColor"
        strokeWidth="1.235"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.375 6.65002H16.625"
        stroke="currentColor"
        strokeWidth="1.235"
      />
    </SvgIcon>
  );
}
